import { connect } from 'react-redux'

// import ShowQuotes from '../Components/ShowQuotes';
import QuoteCards from '../Components/QuoteCards';


const mapStateToProps = state => ( {qRedux: state.Quote } )

  
 
export default connect(mapStateToProps, null)(QuoteCards);
 